export var ACCESS_PERMISSION_PROP;
(function (ACCESS_PERMISSION_PROP) {
    ACCESS_PERMISSION_PROP["LOCATION_IDS"] = "locations";
    ACCESS_PERMISSION_PROP["BRAND_IDS"] = "brands";
    ACCESS_PERMISSION_PROP["BUSINESS_IDS"] = "businesses";
    ACCESS_PERMISSION_PROP["BUSINESS_BRANCH_IDS"] = "bbs";
})(ACCESS_PERMISSION_PROP || (ACCESS_PERMISSION_PROP = {}));
export var ACCESS_PERMISSION_PREFIX = "fs:accessconfig:";
